





















import Vue from 'vue';
export default Vue.extend({
    name: 'Toggler',

    inheritAttrs: false,

    model: {
        prop: 'checked',
        event: 'change',
    },

    props: {
        checked: {
            type: [Boolean],
        },
        yesString: {
            type: String,
        },
        noString: {
            type: String,
        },
    },
});
